/**
 * Links from the member app into the admin panel.
 *
 * The mirror of `gym-admin/member-app-url.ts`, which goes the other way. The
 * two apps are one bundle on different hosts (see `main.tsx`), so a relative
 * path would keep the reader in the member app; swapping the first label is how
 * every cross-app link here resolves, and it keeps LAN hosts
 * (`app.192.168.1.93.sslip.io`) working with no config.
 *
 * `gym.` rather than `admin.`, even for a trophy: both serve the same panel,
 * and `gym.` is the host that exists in every environment today.
 */
export function getGymAdminBaseUrl(): string {
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    const labels = hostname.split('.');
    if (labels.length > 1 && ['app', 'gym', 'admin'].includes(labels[0])) {
      labels[0] = 'gym';
      return `${protocol}//${labels.join('.')}${port ? `:${port}` : ''}`;
    }
  }

  return 'https://gym.divepeaks.local';
}
